import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './SearchSuggestAdornment.css';

interface ISearchSuggestAdornmentProps {
  icon: React.ReactNode;
  onClick?(): void;
}

export const SearchSuggestAdornment: React.FC<ISearchSuggestAdornmentProps> = ({ icon, onClick }) => {
  return (
    <div className={clsx(styles['container'], onClick && styles['clickable'])} onClick={onClick}>
      {icon}
    </div>
  );
};
